import { toast as sonnerToast } from 'sonner'
import { CircleCheck, CircleX, AlertCircle, Info } from 'lucide-react'

interface ToastOptions {
  description?: string
  duration?: number
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
}

const iconProps = {
  size: 16,
  className: 'inline-flex -mt-0.5 me-2',
  'aria-hidden': true,
} as const

export const toast = {
  success: (message: string, options?: ToastOptions): string | number => {
    return sonnerToast.success(
      <span>
        <CircleCheck
          {...iconProps}
          className={`${iconProps.className} text-emerald-500`}
        />
        {message}
      </span>,
      options
    )
  },

  error: (message: string, options?: ToastOptions): string | number => {
    return sonnerToast.error(
      <span>
        <CircleX
          {...iconProps}
          className={`${iconProps.className} text-red-500`}
        />
        {message}
      </span>,
      options
    )
  },

  warning: (message: string, options?: ToastOptions): string | number => {
    return sonnerToast.warning(
      <span>
        <AlertCircle
          {...iconProps}
          className={`${iconProps.className} text-yellow-500`}
        />
        {message}
      </span>,
      options
    )
  },

  info: (message: string, options?: ToastOptions): string | number => {
    return sonnerToast.info(
      <span>
        <Info
          {...iconProps}
          className={`${iconProps.className} text-blue-500`}
        />
        {message}
      </span>,
      options
    )
  },

  // Pass through other methods with explicit typing
  message: sonnerToast.message as (
    message: string,
    options?: ToastOptions
  ) => string | number,
  promise: sonnerToast.promise as any,
  dismiss: sonnerToast.dismiss as (id?: string | number) => void,
  loading: sonnerToast.loading as (
    message: string,
    options?: ToastOptions
  ) => string | number,
}
